<template>
  <div class="insurance-list">
    <insurance-list-item
      v-for="item in data"
      :key="item.key"
      v-bind="item"
    ></insurance-list-item>
  </div>
</template>

<script>
import InsuranceListItem from "./InsuranceListItem"

export default {
  components: {
    InsuranceListItem,
  },
  props: {
    data: {
      type: null,
      default: undefined,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.insurance-list {
  display: flex;
  flex-direction: column;
}
</style>
